// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonSizeVariants } from "@insite/mobius/Button";
import getButtonSizeVariantField from "@store/Framework/Common/Fields/Toolkit/buttonSizeVariant";
import useLanguage from "@store/Framework/Common/Hooks/useLanguage";
import BunzlDownload from "@store/Library/Components/Bunzl/Common/BunzlDownload";

import { ButtonVariant } from "@toolkit/Framework/Types/Button";
import React from "react";

enum fields {
    buttonText = "buttonText",
    buttonSize = "buttonSize",
    buttonVariant = "buttonVariant",
}

interface CreditFormDownloadButtonProps extends WidgetProps {
    fields: {
        [fields.buttonText]: string;
        [fields.buttonSize]: ButtonSizeVariants;
        [fields.buttonVariant]: ButtonVariant;
    };
}

const CreditFormDownloadButton: React.FC<CreditFormDownloadButtonProps> = ({ fields: { buttonText, buttonSize } }) => {
    const downloadLink = useAppSelector(state => state.bunzl.pages.stepForm?.downloadLink);
    const endPoint = useAppSelector(state => state.context.settings.settingsCollection.bunzlSettings?.creditFormApiUrl);
    const language = useLanguage()?.languageCode || "en";
    const handlePDFDownload = () => {
        window.location.href = `${endPoint}creditapplication/pdf/${downloadLink}?language=${language}`;
    };
    if (!downloadLink) {
        return null;
    }
    return (
        <Button sizeVariant={buttonSize} icon={{ src: BunzlDownload, position: "left" }} onClick={handlePDFDownload}>
            {buttonText}
        </Button>
    );
};

const variantField = getButtonSizeVariantField(fields.buttonVariant);
const buttonSizeField = getButtonSizeVariantField(fields.buttonSize);
const widgetModule: WidgetModule = {
    component: CreditFormDownloadButton,
    definition: {
        group: "Common",
        icon: "Download",
        fieldDefinitions: [
            {
                name: fields.buttonText,
                editorTemplate: "TextField",
                defaultValue: "Download",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                ...buttonSizeField.definition,
                defaultValue: "small",
            },
            {
                ...variantField.definition,
                defaultValue: "primary",
            },
        ],
    },
};

export default widgetModule;
